import { render, staticRenderFns } from "./LogisticsDepot.vue?vue&type=template&id=2fc1201b&"
import script from "./LogisticsDepot.vue?vue&type=script&lang=js&"
export * from "./LogisticsDepot.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsDepot.vue?vue&type=style&index=0&id=2fc1201b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports